import angular from 'angular'

angular
  .module('pub.raffles.view', ['pub.raffles.service'])
  .controller('RafflesViewCtrl', RafflesViewCtrl)

/** @ngInject */
function RafflesViewCtrl($scope, $state, $stateParams, RaffleService, TopPrizeService) {
  var vm = this

  vm.items = []
  vm.perPage = 25
  vm.pathImgThumb = ''
  vm.topPrizeID = $stateParams.topPrizeId
  vm.channelId = $stateParams.parentId
  vm.id = $stateParams.id

  TopPrizeService.get(vm.topPrizeID).then(function (result) {
    vm.topPrize = result.results
  })

  RaffleService.get(vm.id).then(function (result) {
    vm.raffle = result.results
  })

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()
  load(1)

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    RaffleService.getWinners(vm.id, vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      vm.winners = result.results
    })
  }

  vm.load = function () {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function (newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.back = function () {
    $state.go('pub.channels.top_prizes.raffles', {
      parentId: $stateParams.parentId,
      topPrizeId: $stateParams.topPrizeId,
    })
  }

  vm.doDrawing = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          RaffleService.doDrawing(vm.id).then(
            function () {
              swal('Drawing completed!', '', 'success')
              load(1)
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  vm.redraw = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          RaffleService.redraw(vm.id, item).then(
            function () {
              swal('Redrawn!', '', 'success')
              load(1)
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }
}
